// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2Fpb-","banner-wrapper":"_38A7M","shake":"_1vjGJ"};